import { Button, Stack, Typography } from '@mui/material';
import { useContext } from 'react';
import { GameContext } from '../../../contexts/GameContext';
import { useTranslation } from '../../../contexts/LanguageContext';

interface ReadyButtonProps {
    isReady: boolean;
}

const ReadyButton = (props: ReadyButtonProps) => {
    const backgroundButton = 'url(/images/buttons/menuButton2.png)';
    const backgroundButtonHover = 'url(/images/buttons/menuButton2_hover.png)';
    const backgroundButtonDisabled = 'url(/images/buttons/menuButton2_disabled.png)';

    const gameContext = useContext(GameContext);
    const { t } = useTranslation();

    const handleClick = async () => {
        if (props.isReady) {
            await gameContext.getClient().CancelPlayerReady();
        } else {
            await gameContext.getClient().ConfirmPlayerReady();
        }
    };

    return (
        <Button
            onClick={handleClick}
            sx={{
                width: 'auto',
                height: 'auto',
                backgroundImage: props.isReady ? backgroundButtonDisabled : backgroundButton,
                backgroundSize: 'cover',
                backgroundPosition: 'left',
                backgroundRepeat: 'no-repeat',
                '&:hover': {
                    backgroundImage: props.isReady ? backgroundButtonDisabled : backgroundButtonHover,
                    cursor: 'pointer'
                },
                opacity: props.isReady ? 0.8 : 1
            }}
        >
            <Stack spacing={2}>
                <Typography variant={'h6'} color={props.isReady ? 'gray' : 'black'} textTransform="none">
                    {props.isReady ? t('waitingReady') : t('readyConfirm')}
                </Typography>
            </Stack>
        </Button>
    );
};

export default ReadyButton;
